export const PARAMS = {
  addRelationshipAgreement: {
    panelId: 'panelId',
  },
  autoProvisionDomainVerification: {
    id: 'id',
    token: 'token',
  },
  clientPayment: {
    id: 'id',
    code: 'code',
  },
  commercialAgreementEdit: {
    commercialAgreementId: 'commercialAgreementId',
  },
  commercialAgreementTemplateReview: {
    commercialAgreementTemplateId: 'commercialAgreementTemplateId',
  },
  commissionConsent: {
    id: 'id',
    code: 'code',
  },
  companyCompassInvite: {
    companyReferralCode: 'companyReferralCode',
  },
  companyCompassInvitePreview: {
    companyReferralCode: 'companyReferralCode',
  },
  companyInvitation: {
    referralCode: 'referralCode',
    companyTypeCode: 'companyTypeCode',
  },
  compassActions: {
    token: 'token',
  },
  compassConfirmSharing: {
    token: 'token',
  },
  compassConfirmSharingViaGlobalLink: {
    companyReferralCode: 'companyReferralCode',
  },
  compassConfirmStart: {
    token: 'token',
  },
  compassPdfGuide: {
    companyId: 'companyId',
  },
  compassPdfReportSection: {
    section: 'section',
  },
  compassDetailsAlreadyOnFile: {
    companyReferralCode: 'companyReferralCode',
  },
  compassSnapshot: {
    token: 'token',
  },
  confirmConsent: {
    id: 'id',
    code: 'code',
  },
  contactUs: {
    companyReferralCode: 'companyReferralCode',
  },
  directLeadCaptureEmbed: {
    companyReferralCode: 'companyReferralCode',
  },
  editLocation: {
    locationId: 'locationId',
  },
  emailAndCalendarReconnect: {
    nylasInvalidGrantId: 'nylasInvalidGrantId',
  },
  inviteUser: {
    id: 'id',
    code: 'code',
  },
  inviteGroupUser: {
    id: 'id',
    code: 'code',
  },
  officeReferralConfirmation: {
    referralId: 'referralId',
  },
  recommendation: {
    referralCode: 'referralCode',
  },
  recommendationGenerateLink: {
    companyReferralCode: 'companyReferralCode',
  },
  referralAffiliateLink: {
    clientCode: 'clientCode',
  },
  referralFeedback: {
    referralId: 'referralId',
    token: 'token',
  },
  referralInvite: {
    referralId: 'referralId',
    token: 'token',
  },
  referralInvites: {
    token: 'token',
  },
  referralLink: {
    referralLinkId: 'referralLinkId',
    referralLinkCode: 'referralLinkCode',
  },
  referralESignatureConsent: {
    referralId: 'referralId',
    callbackCode: 'callbackCode',
  },
  referralESignatureConsentPdf: {
    referralId: 'referralId',
    callbackCode: 'callbackCode',
  },
  referralESignatureConsentPdfPreview: {
    referralId: 'referralId',
  },
  referralIframe: {
    referralId: 'referralId',
  },
  referralRetrospectiveESignatureConsent: {
    referralId: 'referralId',
    callbackCode: 'callbackCode',
  },
  referralSummary: {
    referralId: 'referralId',
  },
  requestCallback: {
    id: 'id',
    code: 'code',
  },
  rescheduleMeeting: {
    id: 'id',
    code: 'code',
  },
  rqCertifiedNdaPdf: {
    companyId: 'companyId',
  },
  shareRecommendation: {
    referralCode: 'referralCode',
  },
  withdrawGdprConsent: {
    id: 'id',
    code: 'code',
  },
}
